// ── Currency ──────────────────────────────────────────────────────────────
export const formatCurrency = (amount) =>
  `₹${Number(amount).toLocaleString('en-IN')}`;

// ── Date / Time ───────────────────────────────────────────────────────────
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${d} ${months[parseInt(m) - 1]} ${y}`;
};

export const formatTime12 = (time24) => {
  if (!time24) return '';
  const [h, m] = time24.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const h12  = h % 12 || 12;
  return `${h12}:${m.toString().padStart(2, '0')} ${ampm}`;
};

// IST-aware today — fixes UTC midnight boundary issues on live servers (UTC+5:30)
export const todayISO = () => {
  const istMs = Date.now() + 5.5 * 60 * 60 * 1000;
  return new Date(istMs).toISOString().split('T')[0];
};

export const formatCountdown = (seconds) => {
  if (seconds <= 0) return '00:00';
  const m = Math.floor(seconds / 60).toString().padStart(2, '0');
  const s = (seconds % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
};

export const isToday = (dateStr) => dateStr === todayISO();

export const isFuture = (dateStr) => dateStr > todayISO();

// ── Status helpers ────────────────────────────────────────────────────────
// statusBadgeClass returns inline style object now (uses centralized STATUS_COLORS)
// For className-based use, import badgeStyle from statusColors instead.
export const statusBadgeClass = (status) => {
  // Kept for backward compat — returns a Tailwind-safe CSS class string
  const map = {
    pending:      'badge-warning',
    confirmed:    'badge-indigo',
    'checked-in': 'badge-teal',
    completed:    'badge-success',
    cancelled:    'badge-danger',
  };
  return map[status] || 'badge-gray';
};

export const statusLabel = (status) => {
  const map = {
    pending:      'Pending',
    confirmed:    'Confirmed',
    'checked-in': 'In Clinic',
    completed:    'Done',
    cancelled:    'Cancelled',
  };
  return map[status] || status;
};

// ── Slot status ───────────────────────────────────────────────────────────
export const slotStatusColor = (delayMinutes) => {
  if (!delayMinutes || delayMinutes === 0) return 'text-success text-xs';
  return 'text-accent text-xs';
};

export const slotStatusText = (delayMinutes) => {
  if (!delayMinutes || delayMinutes === 0) return 'On Time';
  return `${delayMinutes}m delay`;
};

// ── Stars ─────────────────────────────────────────────────────────────────
export const renderStars = (rating, max = 5) => {
  return Array.from({ length: max }, (_, i) => i < Math.round(rating) ? '★' : '☆');
};

// ── Avatar initials ───────────────────────────────────────────────────────
export const getInitials = (name = '') =>
  name.split(' ').map((n) => n[0]).slice(0, 2).join('').toUpperCase();

// ── Conversation ID ───────────────────────────────────────────────────────
export const buildConversationId = (id1, id2) =>
  [id1, id2].sort().join('_');

// ── Phone validation ──────────────────────────────────────────────────────
export const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);

// ── Truncate ──────────────────────────────────────────────────────────────
export const truncate = (str, len = 60) =>
  str?.length > len ? str.slice(0, len) + '…' : str;
